import React, { useContext } from "react";
import { OnlineStatusContext } from "../../context/OnlineStatusContext";
import { formatLastActive } from "../../utils/helpers";

// Active window: 30 seconds - matches backend notification service
// Users are shown as online if they're connected OR were active within last 30 seconds
const ACTIVE_WINDOW_SECONDS = 30;
const ACTIVE_WINDOW_MS = ACTIVE_WINDOW_SECONDS * 1000;

const MemberOnlineStatus = ({ member }) => {
    const onlineUsers = useContext(OnlineStatusContext) || {};

    if (!member) return null;

    const lastActiveTs = member.lastActive ? new Date(member.lastActive).getTime() : null;
    const isActiveByRecency = lastActiveTs ? (Date.now() - lastActiveTs) < ACTIVE_WINDOW_MS : false;
    const isOnlineSocket = onlineUsers[member._id] === true;
    const isOnlinePersisted = member.online === true;

    // User is considered online if:
    // 1. They have an active WebSocket connection (isOnlineSocket), OR
    // 2. They were active within the last 30 seconds (isActiveByRecency), OR
    // 3. They're marked as online in DB and we don't have lastActive data yet
    const isOnline = (isOnlineSocket || isActiveByRecency) || (!member.lastActive && isOnlinePersisted);

    return (
        <div data-tooltip-content={isOnline ? "Online" : formatLastActive(member.lastActive)} data-tooltip-position="bottom" className={`online-indicator ${isOnline ? "online" : "offline"}`}></div>
    );
};

export default MemberOnlineStatus;
